
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/thank-you",
      function () {
        return require("private-next-pages/thank-you.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/thank-you"])
      });
    }
  